import maplibregl from 'maplibre-gl';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { map } from './core/MapView';
import { errorsActions } from '../store';

// The stock "locate me" control. A failure is surfaced through the global
// error handler with the browser's error code, so a phone that refuses the
// request (code 1) can be told apart from one that simply has no fix yet
// (codes 2 and 3).
const MapCurrentLocation = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const control = new maplibregl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true,
        timeout: 10000,
      },
      trackUserLocation: true,
    });
    const onError = (event) => {
      dispatch(errorsActions.push(`Location error ${event.code}: ${event.message}`));
    };
    control.on('error', onError);
    map.addControl(control);
    return () => {
      control.off('error', onError);
      map.removeControl(control);
    };
  }, []);

  return null;
};

export default MapCurrentLocation;
